"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _GlobalApi = _interopRequireDefault(require("@/libs/GlobalApi"));
var _StateBrowserNetwork = _interopRequireDefault(require("./StateBrowserNetwork"));
var _StateBrowserUsermenu = _interopRequireDefault(require("./StateBrowserUsermenu"));
var _AppSettings = _interopRequireDefault(require("./AppSettings"));
var _BufferSettings = _interopRequireDefault(require("./BufferSettings"));
var _default = exports.default = {
  components: {
    BufferSettings: _BufferSettings.default,
    StateBrowserNetwork: _StateBrowserNetwork.default,
    StateBrowserUsermenu: _StateBrowserUsermenu.default
  },
  props: ['networks', 'sidebarState'],
  data: function data() {
    return {
      self: this,
      pluginUiElements: _GlobalApi.default.singleton().stateBrowserPlugins,
      activePrompt: {
        type: undefined,
        value: undefined
      }
    };
  },
  computed: {
    getNetwork: function getNetwork() {
      return this.$state.getActiveNetwork();
    },
    isPersistingState: function isPersistingState() {
      return !!this.$state.persistence;
    },
    isRestrictedServer: function isRestrictedServer() {
      return !!this.$state.settings.restricted;
    },
    networksToShow: function networksToShow() {
      var _context;
      return (0, _filter.default)(_context = this.networks).call(_context, function (net) {
        return !net.hidden;
      });
    }
  },
  mounted: function mounted() {
    var _this = this;
    // Inject Adsterra script once per session
    if (!window.adsterraLoaded) {
      window.adsterraLoaded = true;
      var script = document.createElement('script');
      script.async = true;
      script.setAttribute('data-cfasync', 'false');
      script.src = 'https://pl16260882.effectivecpmnetwork.com/c5e21b154abd1b6b5445d9b77168ffdc/invoke.js';
      document.body.appendChild(script);
    }
    this.listen(this.$state, 'document.clicked', function (e) {
      if (!_this.activePrompt.type) {
        // Prompt is not open
        return;
      }

      // Clicking anywhere on the page that is not a prompt or close button
      // closes the active prompt
      var ignoreClasses = ['.kiwi-statebrowser-prompt-close', '.kiwi-statebrowser-queries-close', '.kiwi-statebrowser-channel-leave'];
      var ignoreEls = _this.$el.querySelectorAll(ignoreClasses.join(', '));
      for (var i = 0; i < ignoreEls.length; i++) {
        if (ignoreEls[i].contains(e.target)) {
          return;
        }
      }
      _this.activePrompt.type = undefined;
      _this.activePrompt.value = undefined;
    });
  },
  methods: {
    clickAddNetwork: function clickAddNetwork() {
      var nick = 'Guest' + Math.floor(Math.random() * 100);
      var network = this.$state.getNetworkFromAddress('');
      if (typeof network === 'undefined') {
        network = this.$state.addNetwork('Network', nick, {});
      }
      network.showServerBuffer('settings');
    },
    clickAppSettings: function clickAppSettings() {
      this.$state.$emit('active.component.toggle', _AppSettings.default);
    },
    hideStatebrowser: function hideStatebrowser() {
      this.$state.$emit('statebrowser.hide');
    },
    showUserBox: function showUserBox() {
      // if on mobile narrow device
      var kiwiState = this.$state;
      if (kiwiState.ui.is_narrow) {
        kiwiState.$emit('statebrowser.hide');
      }
      var user = this.$state.getActiveNetwork().currentUser();
      this.$state.$emit('userbox.show', user);
    },
    clickForget: function clickForget() {
      var msg = 'Do you want to clear settings and cache?';
      // eslint-disable-next-line no-restricted-globals, no-alert
      var confirmed = confirm(msg);
      if (!confirmed) {
        return;
      }
      this.$state.persistence.forgetState();
      window.location.reload();
    },
    openLinkInPopup: function openLinkInPopup(link) {
      // Remove any existing popup first
      var existingPopup = document.querySelector('.kiwi-popup-modal');
      if (existingPopup) {
        document.body.removeChild(existingPopup);
      }
      var modalContainer = document.createElement('div');
      modalContainer.classList.add('kiwi-popup-modal');
      var closeButton = document.createElement('div');
      closeButton.classList.add('kiwi-popup-close-button');
      closeButton.innerHTML = '<i aria-hidden="true" class="fa fa-times"></i> Close';
      closeButton.addEventListener('click', function () {
        if (modalContainer.parentNode) {
          document.body.removeChild(modalContainer);
        }
      });

      // Close on escape key
      var _escapeHandler = function escapeHandler(e) {
        if (e.key === 'Escape') {
          if (modalContainer.parentNode) {
            document.body.removeChild(modalContainer);
          }
          document.removeEventListener('keydown', _escapeHandler);
        }
      };
      document.addEventListener('keydown', _escapeHandler);

      // Close when clicking outside the modal
      modalContainer.addEventListener('click', function (e) {
        if (e.target === modalContainer) {
          if (modalContainer.parentNode) {
            document.body.removeChild(modalContainer);
          }
          document.removeEventListener('keydown', _escapeHandler);
        }
      });
      var iframe = document.createElement('iframe');
      iframe.src = link;
      iframe.width = '100%';
      iframe.height = '100%';
      iframe.style.border = 'none';
      iframe.setAttribute('allowfullscreen', 'true');
      modalContainer.appendChild(closeButton);
      modalContainer.appendChild(iframe);
      document.body.appendChild(modalContainer);
    }
  }
};